import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { Box } from '@chakra-ui/react';
const COLOR = {
    pink: '{colors.btnPrimary}'
};
const EllipseFC = ({ size, variant }) => {
    return _jsx(Box, { w: `${size}px`, h: `${size}px`, borderRadius: '50%', bg: COLOR[variant] });
};
export const Ellipse = memo(EllipseFC);
//# sourceMappingURL=Ellipse.js.map